import Grid from "@mui/material/Grid";
import * as React from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import TelegramIcon from "@mui/icons-material/Telegram";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getFeed } from "services/apiService";
import { useEffect } from "react";
import { useState } from "react";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";
import { postUnLike } from "services/apiService";
import { postLike } from "services/apiService";
import { postComment } from "services/apiService";
import LikesDialog from "layouts/dialogModals/LikesDialog";
import CommentsDialog from "layouts/dialogModals/CommentDialog";
import Moment from "react-moment";
import { getPostById } from "services/apiService";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ShareDialog from "layouts/dialogModals/ShareDialog";

function PublicPostDetails() {
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [post, setPost] = useState("");
  const [comment, setComment] = useState("");
  const [postId, setPostId] = useState("");
  const [likeDialogBoolean, setLikeDialogBoolean] = useState(false);
  const [commentDialogBoolean, setCommentDialogBoolean] = useState(false);
  const [feedLoading, setFeedLoading] = useState(true);
  const [shareDialogBoolean, setShareDialogBoolean] = useState(false);

  useEffect(() => {
    fetchPostById();
  }, []);

  const fetchPostById = async () => {
    const getPostByIdRes = await getPostById(searchParams.get("p_source"));
    // console.log("getPostBydIDRes", getPostByIdRes);
    setPost(getPostByIdRes[0]);
  };
  const handleUsernameClick = (username) => {
    navigate(`/profile/?username=${username}`);
  };

  const handleLikeUnLike = async (isLikedBoolean, postId) => {
    const postID = {
      postID: postId,
    };
    if (isLikedBoolean) {
      const postUnlikeRes = await postUnLike(postID);
      // console.log("postUnLikeRes", postUnlikeRes);

      const postByIdRes = await getPostById(postId);
      // console.log("postByid", postByIdRes);

      //   const replacePostById = (post, postByIdRes) => {
      //     return post.map((item) => {
      //       if (item._id === postByIdRes[0]._id) {
      //         return postByIdRes[0];
      //       }
      //       return item;
      //     });
      //   };

      //   const updatedPost = replacePostById(post, postByIdRes);
      setPost(postByIdRes[0]);

      // setLikeState((prev) => !prev);
    } else {
      const postLikeRes = await postLike(postID);
      // console.log("postLikeRes", postLikeRes);

      const postByIdRes = await getPostById(postId);
      // console.log("postByid", postByIdRes);

      //   const replacePostById = (post, postByIdRes) => {
      //     return post.map((item) => {
      //       if (item._id === postByIdRes[0]._id) {
      //         return postByIdRes[0];
      //       }
      //       return item;
      //     });
      //   };

      //   const updatedPost = replacePostById(post, postByIdRes);
      setPost(postByIdRes[0]);

      // setLikeState((prev) => !prev);
    }
  };

  const handleInputChange = (value, postId) => {
    setComment({
      // ...comment,
      [postId]: value,
    });
  };

  const handlePostComment = async (postId) => {
    if (comment === "") {
      // console.log("empty comment");
      // Swal.fire("Cannot post empty comment", "", "warning");
    }

    const postComData = {
      comment: comment[postId],
      postID: postId,
    };

    const postComRes = await postComment(postComData);
    // console.log("postComRes", postComRes);
    setComment("");

    const postByIdRes = await getPostById(postId);
    // console.log("postByid", postByIdRes);

    // const replacePostById = (post, postByIdRes) => {
    //   return post.map((item) => {
    //     if (item._id === postByIdRes[0]._id) {
    //       return postByIdRes[0];
    //     }
    //     return item;
    //   });
    // };

    // const updatedPost = replacePostById(post, postByIdRes);
    setPost(postByIdRes[0]);

    // setCommentState((prev) => !prev);
  };

  const openLikesDialog = (value) => {
    // console.log("postID", value);
    setPostId(value);
    setLikeDialogBoolean(true);
  };

  const handleCloseLikeDialog = () => {
    setLikeDialogBoolean(false);
  };

  const openCommentsDialog = (value) => {
    // console.log("postID", value);
    setPostId(value);
    setCommentDialogBoolean(true);
  };

  const handleCloseCommentDialog = () => {
    setCommentDialogBoolean(false);
  };

  const handleVideoClick = (item) => {
    navigate(`/reels`, { state: item });
  };

  const handleShare = (postId) => {
    setPostId(postId);
    setShareDialogBoolean(true);
  };

  const handleCloseShareDialog = () => {
    setShareDialogBoolean(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid container spacing={3} gap={2}>
          <Grid item xs={12} md={6} lg={8}>
            <MDBox mb={3}>
              <Card sx={{ border: "1px solid #6a6a6a" }}>
                <CardHeader
                  sx={{ padding: "10px" }}
                  avatar={
                    <MDAvatar
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleUsernameClick(post.username)}
                      src={post.pic}
                      imgProps={{
                        style: { height: "100%", width: "100%" },
                      }}
                    />
                  }
                  title={
                    <MDTypography
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleUsernameClick(post.username)}
                    >
                      {post.username}
                    </MDTypography>
                  }
                />
                <MDBox
                  // onClick={handleVideo}
                  sx={{ height: "320px" }}
                >
                  {post.postType === "video" ? (
                    <>
                      <video
                        onClick={() => handleVideoClick(post)}
                        // ref={videoRef}
                        height="100%"
                        width="100%"
                        style={{
                          cursor: "pointer",
                          position: "relative",
                        }}
                        // src={item.photo}
                        // autoPlay
                        // loop
                        // muted
                        // controls
                      >
                        <source src={post.photo} type="video/mp4" />
                      </video>
                      <MDTypography
                        fontSize="50px"
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleVideoClick(post)}
                      >
                        <PlayCircleOutlineIcon
                          sx={{
                            position: "absolute",
                            top: "40%",
                            right: "47%",
                          }}
                        />
                      </MDTypography>
                    </>
                  ) : (
                    <img
                      style={{ objectFit: "cover" }}
                      src={post.photo}
                      height="100%"
                      width="100%"
                      alt="image"
                    />
                  )}
                </MDBox>

                <CardActions disableSpacing>
                  <MDBox sx={{ display: "flex", alignItems: "center" }}>
                    <IconButton
                      aria-label="add to favorites"
                      onClick={() => handleLikeUnLike(post.isLiked, post._id)}
                    >
                      {post.isLiked ? (
                        <FavoriteIcon style={{ color: "red" }} />
                      ) : (
                        <FavoriteBorderIcon style={{ color: "#fff" }} />
                      )}
                    </IconButton>
                    <MDTypography
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                      onClick={() => openLikesDialog(post._id)}
                    >
                      {post.totalLike}
                    </MDTypography>
                  </MDBox>
                  {/* &nbsp;&nbsp; */}
                  <MDBox sx={{ display: "flex", alignItems: "center" }}>
                    <IconButton onClick={() => openCommentsDialog(post._id)}>
                      <ChatBubbleOutlineIcon style={{ color: "#fff" }} />
                    </IconButton>
                    <MDTypography
                      fontWeight="bold"
                      sx={{ cursor: "pointer" }}
                      onClick={() => openCommentsDialog(post._id)}
                    >
                      {post.totalComment}
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ display: "flex", alignItems: "center" }}>
                    <IconButton onClick={() => handleShare()}>
                      <TelegramIcon style={{ color: "#fff" }} />
                    </IconButton>
                  </MDBox>
                </CardActions>
                <CardContent
                  sx={{
                    paddingTop: 0,
                    paddingBottom: 0,
                  }}
                >
                  <MDTypography fontWeight="bold" fontSize="15px">
                    {post.caption}
                  </MDTypography>
                  <MDTypography fontSize="15px" sx={{ color: "grey" }}>
                    <Moment fromNow>{post.updatedTime}</Moment>
                  </MDTypography>
                </CardContent>
                <MDBox
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <IconButton sx={{ p: "5px" }}>
                    <MDAvatar
                      src={post.pic}
                      sx={{
                        cursor: "pointer",
                        width: "2.5rem",
                        height: "2.5rem",
                      }}
                      imgProps={{
                        style: { height: "100%", width: "100%" },
                      }}
                    />
                  </IconButton>
                  <InputBase
                    sx={{
                      ml: 1,
                      flex: 1,
                      fontSize: "18px",
                    }}
                    placeholder="Add a comment"
                    inputProps={{ style: { color: "#fff" } }}
                    value={comment[post._id] || ""}
                    onChange={(e) =>
                      handleInputChange(e.target.value, post._id)
                    }
                  />

                  <IconButton
                    disabled={comment === "" || !/\S/.test(comment[post._id])}
                    sx={{}}
                    onClick={() => handlePostComment(post._id)}
                  >
                    <MDTypography
                      sx={{
                        color:
                          comment === "" || !/\S/.test(comment[post._id])
                            ? "grey"
                            : "",
                        fontSize: "18px",
                      }}
                    >
                      Post
                    </MDTypography>
                  </IconButton>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
        {shareDialogBoolean && (
          <ShareDialog
            openStatus={shareDialogBoolean}
            onClose={() => handleCloseShareDialog()}
            postId={postId}
          />
        )}

        {likeDialogBoolean && (
          <LikesDialog
            openStatus={likeDialogBoolean}
            onClose={() => handleCloseLikeDialog()}
            postId={postId}
          />
        )}

        {commentDialogBoolean && (
          <CommentsDialog
            openStatus={commentDialogBoolean}
            onClose={() => handleCloseCommentDialog()}
            postId={postId}
          />
        )}
      </MDBox>
    </DashboardLayout>
  );
}

export default PublicPostDetails;
